export default __webpack_public_path__ + "static/award4-c2512fe72a23ac070082142f7f423591.jpg";